import { resetKeyDown } from '../State/keyDown'

export default () => (dispatch) => {

  dispatch(resetKeyDown())

}
